module.exports = __webpack_public_path__ + "img/plena.f996e9ff.png";